<template>
  <!-- 抄表计划 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="计划名称">
              <a-input v-model="query.planName" placeholder="请输入计划名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="抄表员">
              <a-select placeholder="请选择" default-value v-model="query.readerId" allow-clear>
                <a-select-option v-for="item in meterReaderList" :key="item.id" :value="item.id">
                  {{ item.readerName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="表册分组">
              <a-select placeholder="请选择" v-model="query.groupId" allow-clear @change="onQueryGroupChange">
                <a-select-option v-for="item in bookGroupList" :key="item.id" :value="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="表册">
              <a-select 
                placeholder="请选择" 
                v-model="query.bookId" 
                allow-clear 
                show-search
                :filter-option="filterMeterBookOption"
                :disabled="!query.groupId"
              >
                <a-select-option v-if="!query.groupId" disabled value=""> 请先选择表册分组 </a-select-option>
                <a-select-option v-for="item in filteredQueryMeterBooksList" :key="item.id" :value="item.id">
                  {{ item.bookName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item>
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateH()" v-action:add>新增 </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      size="middle"
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="status" slot-scope="text">
        <a-tag :color="text === 0 ? 'rgb(255, 99, 71)' : text === 1 ? 'rgb(50, 205, 50) ' : 'green'">{{
          text === 0 ? '未生成' : text === 1 ? '已生成' : '已完成'
        }}</a-tag>
      </span>
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
      <span slot="action" slot-scope="text, record">
        <span style="padding: 0 6px"></span>
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <!-- 新增 -->
    <a-modal
      :title="currentId ? '编辑' : '新增'"
      style="top: 20px"
      :width="600"
      :visible="visibles"
      @ok="debounceSubmit"
      @cancel="handleCancelh"
      class="centered-modal"
      :confirmLoading="isSubmitting"
      :okButtonProps="{ disabled: isSubmitting }"
    >
      <a-alert
        class="prompt"
        style="margin: 15px 0"
        type="info"
        show-icon
        message="计划保存后，系统将在抄表开始日期当天的00:00:00自动生成任务。"
      />
      <a-form-model
        class="log-form centered-form"
        :model="engineeringProjectEstab"
        ref="ruleForm"
        :rules="rule"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="计划名称" prop="planName" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.planName" />
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="表册分组" prop="groupId">
          <a-select
            placeholder="请选择"
            default-value
            v-model="engineeringProjectEstab.groupId"
            allow-clear
            show-search
            :filter-option="filterGroupOption"
            @change="handleGroupIdChange"
            :disabled="!!currentId"
          >
            <a-select-option v-for="item in bookGroupList" :key="item.id" :value="item.id">
              {{ item.groupName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="抄表表册：" prop="bookIds">
          <a-select
            placeholder="请选择"
            class="custom-multi-select"
            :disabled="!engineeringProjectEstab.groupId || !!currentId"
            v-model="engineeringProjectEstab.bookIds"
            mode="multiple"
            :loading="meterBooksLoading"
            allow-clear
            show-search
            :filter-option="filterBookOption"
            @change="handleBookIdsChange"
          >
            <a-select-option
              v-for="item in filteredMeterBooksList"
              :key="item.id"
              :value="item.id"
              :disabled="item.selectable === false"
            >
              {{ item.bookName }}
              <!-- <span v-if="item.selectable === false" style="color: #ccc; margin-left: 8px;">(不可选)</span> -->
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="抄表员" prop="readerId">
          <a-select placeholder="请选择" default-value v-model="engineeringProjectEstab.readerId" allow-clear>
            <a-select-option v-for="item in meterReaderList" :key="item.id" :value="item.id">
              {{ item.readerName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          prop="cycleType"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :disabled="disabled || !!currentId"
          label="抄表周期"
          hasFeedback
        >
          <a-select placeholder="请选择抄表周期" v-model="engineeringProjectEstab.cycleType" :disabled="!!currentId">
            <a-select-option v-for="item in monthList" :key="item.key" :value="item.key" :label="item.label">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="抄表开始日期" prop="startDate">
          <a-date-picker
            v-model="engineeringProjectEstab.startDate"
            :disabled-date="disabledStartDate"
            @change="onChangeh"
            style="width: 100%"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            @openChange="handleStartOpenChange"
            :disabled="!!currentId"
          />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="抄表结束日期" prop="endDate">
          <a-date-picker
            v-model="engineeringProjectEstab.endDate"
            :disabled-date="disabledEndDate"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            style="width: 100%"
            :open="endOpen"
            @change="onChanget"
            @openChange="handleEndOpenChange"
            :disabled="!!currentId"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 自定义删除确认对话框 -->
    <a-modal
      title="删除提示"
      :visible="deleteConfirmVisible"
      @ok="confirmDelete"
      @cancel="cancelDelete"
      :width="400"
      :closable="true"
      :maskClosable="false"
      okText="确定"
      cancelText="取消"
      okType="primary"
      class="delete-confirm-modal"
    >
      <div style="text-align: center">
        <!-- 警告信息 -->
        <a-alert
          message="计划删除后，将不再生成对应的定时任务!"
          type="warning"
          show-icon
          style="margin-bottom: 20px; text-align: left"
        />
        <!-- 确认问题 -->
        <p style="font-size: 16px; margin: 0">请确认是否删除勾选计划?</p>
      </div>
    </a-modal>

    <!-- 编辑成功提示弹窗 -->
    <a-modal
      title="提示"
      :visible="editSuccessVisible"
      @ok="closeEditSuccessModal"
      :width="500"
      :closable="true"
      :maskClosable="false"
      :cancelButtonProps="{ style: { display: 'none' } }"
      okText="确定"
      okType="primary"
      class="edit-success-modal"
    >
      <div style="text-align: center">
        <!-- 提示信息 -->
        <p style="font-size: 16px; color: #333; margin: 0; line-height: 1.6">
          {{ editSuccessMessage }}
        </p>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import dayjs from 'dayjs'
import mixinViewModule from '@/mixin/common'

const monthList = [
  { key: 1, label: '每月抄表' },
]
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  { title: '计划名称', dataIndex: 'planName', key: 'name' },
  { title: '表册分组', dataIndex: 'groupName', key: 'bookGroup' },
  {
    title: '抄表表册',
    dataIndex: 'meterBooks',
    key: 'bookName',
    customRender: (meterBooks, record) => {
      // 如果直接有meterBooks数组
      if (meterBooks && Array.isArray(meterBooks)) {
        return meterBooks.map((book) => book.bookName).join('、')
      }
      // 如果是字符串形式的bookName
      else if (record.bookName) {
        return record.bookName
      }
      // 如果是bookNames数组
      else if (record.bookNames && Array.isArray(record.bookNames)) {
        return record.bookNames.join('、')
      }
      return ''
    },
  },
  { title: '抄表员', dataIndex: 'readerName', key: 'staffName' },
  { title: '抄表周期', dataIndex: 'cycleTypeText', key: 'taskFrequency' },
  { title: '抄表开始日期', dataIndex: 'startDate', key: 'startDate' },
  { title: '抄表结束日期', dataIndex: 'endDate', key: 'endDate' },
  { title: '计划创建时间', dataIndex: 'createTime', key: 'createTime' },
  { title: '操作', width: '150px', dataIndex: 'action', scopedSlots: { customRender: 'action' }, key: 'action' },
]

export default {
  components: {
    dayjs,
  },
  mixins: [mixinViewModule],
  name: 'Task',
  data() {
    return {
      isMonth: false,
      monthList,
      dayjs,
      importLoading: false,
      visibles: false,
      endOpen: false,
      disabled: false,
      fileList: [],
      queryUrl: '/meter-manager/meter_reading_plans/page',
      addOrUpdateUrl: '/meter-manager/meter_reading_plans/create',
      queryOneUrl: '/meter-manager/meter_reading_plans/detail',
      deleteUrl: '/meter-manager/meter_reading_plans/batch',
      meterReaderqueryUrl: '/meter-manager/meter_readers/list',
      bookGroupUrl: '/meter-manager/meter_book_groups/list',
      meterBooksUrl: '/meter-manager/meter_reading_plans/meter-books',
      staffTreeData: [], // 分区数据选项
      meterReaderList: [], // 抄表员列表
      bookGroupList: [], // 表册分组列表
      meterBooksList: [], // 表册列表
      filteredMeterBooksList: [], // 根据分组筛选的表册列表
      meterBooksLoading: false, // 表册加载状态
      query: {
        planName: '',
        readerId: '',
        groupId: '',
        bookId: '',
      },
      engineeringProjectEstab: {
        planName: '',
        groupId: '',
        bookIds: [],
        readerId: '',
        cycleType: '',
        startDate: '',
        endDate: '',
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      rule: {
        planName: [{ required: true, message: '请输入计划名称', trigger: 'change' }],
        cycleType: [{ required: true, message: '请选择计划周期', trigger: 'change' }],
        startDate: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        endDate: [{ required: true, message: '请选择计划结束时间', trigger: 'change' }],
        groupId: [{ required: true, message: '请选择表册分组', trigger: 'change' }],
        bookIds: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (Array.isArray(value) && value.length === 0)) {
                callback(new Error('请选择抄表表册'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        readerId: [{ required: true, message: '请选择抄表员', trigger: 'change' }],
      },
      // 删除确认对话框状态
      deleteConfirmVisible: false,
      // 编辑成功提示弹窗状态
      editSuccessVisible: false,
      editSuccessMessage: '',
      // 防抖相关状态
      isSubmitting: false,
      submitTimer: null,
    }
  },

  created() {
    this.getMeterReaderData()
    this.getBookGroupData()
  },
  methods: {
    // 根据id 修改
    addOrUpdateHandle(id) {
      this.disabled = true
      this.isUpdate = false
      this.visibles = true
      this.currentId = id
      this.RightData = []

      // 重置防抖状态
      this.isSubmitting = false
      if (this.submitTimer) {
        clearTimeout(this.submitTimer)
        this.submitTimer = null
      }

      if (id) {
        this.isUpdate = true
        // 编辑时禁用不可修改的字段
        this.disabled = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            // 从meterBooks数组中提取meterBookId
            let bookIds = []
            if (data.meterBooks && Array.isArray(data.meterBooks)) {
              bookIds = data.meterBooks.map((book) => book.meterBookId)
            } else if (data.bookIds) {
              // 兼容处理：如果直接返回bookIds
              bookIds = Array.isArray(data.bookIds) ? data.bookIds : [data.bookIds]
            } else if (data.bookId) {
              // 兼容处理：如果返回单个bookId
              if (Array.isArray(data.bookId)) {
                bookIds = data.bookId
              } else if (typeof data.bookId === 'string' && data.bookId.includes(',')) {
                bookIds = data.bookId
                  .split(',')
                  .map((id) => id.trim())
                  .filter(Boolean)
              } else if (data.bookId) {
                bookIds = [data.bookId]
              }
            }

            this.engineeringProjectEstab = {
              planName: data.planName,
              groupId: data.groupId,
              bookIds: bookIds,
              readerId: data.readerId,
              cycleType: data.cycleType,
              startDate: data.startDate,
              endDate: data.endDate,
            }
            if (data.cycleType == 1) {
              this.isMonth = true
            } else {
              this.isMonth = false
            }
            // 如果有分组ID，先加载对应的表册
            if (data.groupId) {
              this.getMeterBooksData(data.groupId).then(() => {
                // 确保在表册列表加载完成后，bookIds已经正确设置
                this.$nextTick(() => {
                  // 重新设置bookIds，确保响应式更新，不自动移除不可选的表册
                  this.$set(this.engineeringProjectEstab, 'bookIds', bookIds)
                })
              })
            }
          })
          .catch(() => {})
      } else {
        // 新增时重置表单
        this.engineeringProjectEstab = {
          planName: '',
          groupId: '',
          bookIds: [],
          readerId: '',
          cycleType: '',
          startDate: '',
          endDate: '',
        }
        // 重置表册列表
        this.filteredMeterBooksList = []
      }
    },
    // 时间
    disabledStartDate(current) {
      // 不能选择今天及之前的日期，只能选择明天及以后的日期
      return current && current <= dayjs().endOf('day')
    },
    disabledEndDate(endDate) {
      const startDate = this.engineeringProjectEstab.startDate

      // 首先确保不能选择今天及之前的日期
      if (endDate && endDate <= dayjs().endOf('day')) {
        return true
      }

      // 其次确保不能选择早于开始日期的日期
      if (!endDate || !startDate) {
        return false
      }
      return startDate.valueOf() >= endDate.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },

    onChangeh(date, dateString) {
      console.log(dateString)
      this.engineeringProjectEstab.startDate = dateString
      this.engineeringProjectEstab.startDate = date
    },
    onChanget(date, dateString) {
      this.engineeringProjectEstab.endDate = dateString
      this.engineeringProjectEstab.endDate = date
    },
    addOrUpdateH() {
      this.disabled = false
      this.visibles = true
      // 新增时启用所有字段
      this.currentId = null

      // 重置防抖状态
      this.isSubmitting = false
      if (this.submitTimer) {
        clearTimeout(this.submitTimer)
        this.submitTimer = null
      }

      // 使用$set重置表单数据，确保响应式更新
      this.$set(this, 'engineeringProjectEstab', {
        planName: '',
        groupId: '',
        bookIds: [], // 确保是空数组
        readerId: '',
        cycleType: '',
        startDate: '',
        endDate: '',
      })

      // 重置表册相关状态
      this.filteredMeterBooksList = []
      this.meterBooksLoading = false

      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields()
        }
      })
    },
    handleCancelh() {
      this.visibles = false
      this.isMonth = false
      this.endOpen = false
      this.currentId = null
      this.disabled = false

      // 重置防抖状态
      this.isSubmitting = false
      if (this.submitTimer) {
        clearTimeout(this.submitTimer)
        this.submitTimer = null
      }

      // 重置表单验证
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }

      // 使用$set重置表单数据，确保响应式更新
      this.$set(this, 'engineeringProjectEstab', {
        planName: '',
        groupId: '',
        bookIds: [], // 确保是空数组
        readerId: '',
        cycleType: '',
        startDate: '',
        endDate: '',
      })

      // 重置表册相关状态
      this.filteredMeterBooksList = []
      this.meterBooksLoading = false
    },
    approvalko() {
      // 防抖处理：如果正在提交中，直接返回
      if (this.isSubmitting) {
        return
      }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 设置提交状态，防止重复提交
          this.isSubmitting = true
          
          let params = {}

          if (this.currentId) {
            // 编辑时传递所有字段
            params = {
              id: this.currentId,
              ...this.engineeringProjectEstab,
              startDate: this.engineeringProjectEstab.startDate,
              endDate: this.engineeringProjectEstab.endDate,
              // bookIds已经通过v-model保证是数组格式，直接使用
              bookIds: this.engineeringProjectEstab.bookIds,
            }
          } else {
            // 新增时传递所有字段
            params = {
              ...this.engineeringProjectEstab,
              startDate: this.engineeringProjectEstab.startDate,
              endDate: this.engineeringProjectEstab.endDate,
              // bookIds已经通过v-model保证是数组格式，直接使用
              bookIds: this.engineeringProjectEstab.bookIds,
            }
          }

          this.$http[!this.currentId ? 'post' : 'put'](
            !this.currentId ? this.addOrUpdateUrl : '/meter-manager/meter_reading_plans/update',
            params
          ).then((res) => {
            if (res.code == 0) {
              this.visibles = false
              this.queryList()
              // 根据是新增还是编辑显示不同的提示信息
              if (this.currentId) {
                // 编辑成功 - 显示弹窗提示
                this.editSuccessMessage = `您已调整"${this.engineeringProjectEstab.planName}"计划，新的抄表任务将根据调整后的计划生成`
                this.editSuccessVisible = true
              } else {
                // 新增成功
                return this.$message.success(res.message)
              }
            } else {
              this.visibles = false
              return this.$message.warn(res.message)
            }
          }).catch((error) => {
            console.error('提交失败:', error)
            this.$message.error('操作失败，请重试')
          }).finally(() => {
            // 无论成功还是失败，都要重置提交状态
            this.resetSubmitState()
          })
        } else {
          console.log('表单验证失败')
          return false
        }
      })
    },

    // 重置提交状态
    resetSubmitState() {
      // 清除定时器
      if (this.submitTimer) {
        clearTimeout(this.submitTimer)
        this.submitTimer = null
      }
      
      // 延迟重置提交状态，防止快速重复点击
      this.submitTimer = setTimeout(() => {
        this.isSubmitting = false
      }, 1000) // 1秒防抖时间
    },

    // 防抖提交方法
    debounceSubmit() {
      // 清除之前的定时器
      if (this.submitTimer) {
        clearTimeout(this.submitTimer)
      }
      
      // 设置新的定时器
      this.submitTimer = setTimeout(() => {
        this.approvalko()
      }, 300) // 300ms防抖延迟
    },
    changeFrequency(val) {
      if (val == '月') {
        this.isMonth = true
      } else {
        this.isMonth = false
        this.engineeringProjectEstab.cycleType = ''
      }
    },

    handleOk(e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          var params = {
            id: this.currentId,
            ...values,
          }
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    historyData() {
      this.$refs.historyModal.show()
    },

    getMeterReaderData() {
      this.$http.get(this.meterReaderqueryUrl).then(({ data }) => {
        this.meterReaderList = data
      })
    },
    getBookGroupData() {
      this.$http.get(this.bookGroupUrl).then(({ data }) => {
        this.bookGroupList = data
      })
    },
    getMeterBooksData(groupId = null) {
      this.meterBooksLoading = true

      // 新的API接口可能需要不同的参数格式
      let url = this.meterBooksUrl
      if (groupId) {
        url = `${this.meterBooksUrl}?groupId=${groupId}`
      }

      return this.$http
        .get(url)
        .then(({ data }) => {
          // 确保返回的数据是数组格式
          const bookList = Array.isArray(data) ? data : data.list || data.data || []
          this.meterBooksList = bookList
          this.filteredMeterBooksList = bookList
          this.meterBooksLoading = false
          return bookList // 返回加载的数据，以便后续处理
        })
        .catch((error) => {
          console.error('获取表册列表失败:', error)
          this.meterBooksLoading = false
          this.$message.error('获取表册列表失败')
          // 如果API调用失败，设置为空数组
          this.meterBooksList = []
          this.filteredMeterBooksList = []
          return [] // 返回空数组
        })
    },
    changeFile(info) {},
    // 处理表册分组变化
    handleGroupIdChange(groupId) {
      // 清空已选择的表册
      this.$set(this.engineeringProjectEstab, 'bookIds', [])

      // 重置表册列表
      this.filteredMeterBooksList = []
      this.meterBooksLoading = true

      // 根据分组ID获取表册
      if (groupId) {
        this.getMeterBooksData(groupId)
      } else {
        // 如果没有选择分组，清空表册列表
        this.filteredMeterBooksList = []
        this.meterBooksLoading = false
      }
    },

    // 处理表册选择变化
    handleBookIdsChange(bookIds) {
      // 不自动移除不可选的表册，只是记录选择变化
      console.log('表册选择变化:', bookIds)
    },
    onQueryGroupChange() {
      this.query.bookId = ''
      if (this.query.groupId) {
        this.getMeterBooksData(this.query.groupId)
      } else {
        this.meterBooksList = []
      }
    },
    resetList() {
      this.query = {
        planName: '',
        readerId: '',
        groupId: '',
        bookId: '',
      }
      this.meterBooksList = []
      this.queryList()
    },

    // 重写删除方法，使用自定义确认对话框
    deleteSelectRow() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      // 显示自定义删除确认对话框
      this.deleteConfirmVisible = true
    },

    // 确认删除
    confirmDelete() {
      this.$http
        .delete(this.deleteUrl, {
          data: this.selectedRows,
        })
        .then((res) => {
          if (res.code === 0) {
            this.$message.success(`共删除${this.selectedRows.length}条数据`)
            this.selectedRows = []
            this.deleteConfirmVisible = false
            this.queryList()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        })
        .catch(() => {
          this.$message.error('删除失败')
        })
    },

    // 取消删除
    cancelDelete() {
      this.deleteConfirmVisible = false
      this.selectedRows = []
      this.$message.info('已取消删除')
    },

    // 关闭编辑成功提示弹窗
    closeEditSuccessModal() {
      this.editSuccessVisible = false
      this.editSuccessMessage = ''
    },

    // 表册分组模糊查询过滤
    filterGroupOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    // 抄表表册模糊查询过滤
    filterBookOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    // 查询表单中表册选择器的搜索过滤函数
    filterMeterBookOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
  computed: {
    filteredQueryMeterBooksList() {
      // meterBooksList 已经是当前分组下的表册
      return this.meterBooksList
    },
  },
  watch: {},
  beforeDestroy() {
    // 组件销毁前清理定时器
    if (this.submitTimer) {
      clearTimeout(this.submitTimer)
      this.submitTimer = null
    }
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}

/deep/ .ant-modal-body {
  padding: 24px;
}

/deep/ .custom-multi-select .ant-select-selection {
  min-height: 35px; /* 最小高度 */
  max-height: 60px; /* 最大高度限制 */
  overflow-y: auto;
}
.centered-form {
  max-width: 90%;
  margin: 0 auto;

  /deep/ .ant-form-item {
    margin-bottom: 20px;

    .ant-form-item-label {
      text-align: right;
      padding-right: 12px;
    }

    .ant-form-item-control {
      text-align: left;
      height: 30px;
    }
  }

  /deep/ .ant-select,
  /deep/ .ant-input,
  /deep/ .ant-picker {
    width: 100%;
  }
}

.centered-modal {
  /deep/ .ant-modal-content {
    .ant-modal-header {
      padding: 16px 24px;
      .ant-modal-title {
        text-align: center;
        font-size: 18px;
        font-weight: 500;
      }
    }

    .ant-modal-body {
      max-height: 80vh;
      overflow-y: auto;
      padding-top: 10px;
    }

    .ant-modal-footer {
      text-align: center;
      padding: 16px 24px;

      .ant-btn {
        min-width: 80px;
        margin: 0 8px;
      }
    }
  }
}

//调整提示消息位置
/deep/ .prompt.ant-alert {
  display: flex;
  align-items: center;
  text-align: center;
}

//调整提示图标位置
/deep/ .prompt .ant-alert-icon {
  margin-right: 20px; /* 图标与文字间距 */
  position: relative;
  top: -1px;
}

// 删除确认对话框样式
/deep/ .ant-modal-confirm {
  .ant-modal-confirm-title {
    display: flex;
    align-items: center;

    &::before {
      content: '';
      display: inline-block;
      width: 16px;
      height: 16px;
      background: #ff4d4f;
      border-radius: 50%;
      margin-right: 8px;
    }
  }

  .ant-modal-confirm-content {
    margin-top: 16px;
  }
}

// 自定义删除对话框样式
.delete-confirm-modal {
  /deep/ .ant-modal-header {
    border-bottom: 1px solid #f0f0f0;
    padding: 16px 24px;

    .ant-modal-title {
      color: #333;
      font-weight: 500;
      font-size: 16px;
      display: flex;
      align-items: center;
    }
  }

  /deep/ .ant-modal-body {
    padding: 24px;

    .ant-alert {
      border: 1px solid #faad14;
      background-color: #fffbe6;

      .ant-alert-icon {
        color: #faad14;
      }

      .ant-alert-message {
        color: #333;
        font-weight: 500;
      }
    }

    p {
      color: #333;
      font-size: 16px;
      margin: 0;
      text-align: center;
    }
  }

  /deep/ .ant-modal-footer {
    border-top: 1px solid #f0f0f0;
    padding: 16px 24px;
    text-align: right;

    .ant-btn {
      margin-left: 8px;
      min-width: 80px;
      height: 32px;
      border-radius: 4px;

      &.ant-btn-primary {
        background-color: #1890ff;
        border-color: #1890ff;
      }

      &.ant-btn-default {
        border-color: #d9d9d9;
        color: #333;
      }
    }
  }
}

// 编辑成功弹窗样式
.edit-success-modal {
  /deep/ .ant-modal-header {
    border-bottom: 1px solid #f0f0f0;
    padding: 16px 24px;

    .ant-modal-title {
      color: #333;
      font-weight: 500;
      font-size: 16px;
      display: flex;
      align-items: center;
    }
  }

  /deep/ .ant-modal-body {
    padding: 24px;
  }
}

// 防抖提交状态样式
/deep/ .ant-modal-footer {
  .ant-btn-primary {
    &.ant-btn-loading {
      pointer-events: none;
      opacity: 0.7;
    }
  }
}

// 提交中状态下的按钮样式
/deep/ .ant-btn[disabled] {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
